<template>
	<div class="wrapper">
		<sub-ibox-title :is-show-back=true>
			<p slot="title">{{params.id ? '编辑商家':'新增商家'}}</p>
		</sub-ibox-title>
		<section class="content">
			<div class="detail-cont">
				<z-input maxlength=20 title="商家名称" class="m-t-15" v-model.trim="params.username" isMust=true></z-input>
				<z-input type="email" maxlength=11 title="登录账号" placeholder="请输入手机号码" class="m-t-15" v-model.trim="params.phone" isMust=true></z-input>
				<z-input maxlength=20 title="登录密码" placeholder="默认：888888" disabled="disabled" class="m-t-15" ></z-input>
				<div class="fx fx-y-center m-t-20">
					<p class="title fx w120 m-r-5"><i class="ask">&nbsp;&nbsp;</i><span class="fx-fill">商家logo</span></p>
					<z-upload :file-url='params.logo_url' :on-success="handleUploadSuccess"></z-upload>
					<div class="pic-tips m-l-10">建议尺寸：200*200</div>
				</div>
				<z-input maxlength=20 title="神马付商户ID" class="m-t-15" v-model.trim="params.partnerId"></z-input>
                <z-input type="textarea" title="神马付签名" class="m-t-15" v-model.trim="params.sign"></z-input>
				<!--<z-input type="textarea" title="神马付公钥" class="m-t-15" v-model.trim="params.public_key"></z-input>-->
				<!--<z-input type="textarea"  title="神马付私钥" class="m-t-15" v-model.trim="params.private_key"></z-input>-->
				<z-input title="微信/支付宝结算手续费率" placeholder="如：0.006" class="m-t-15" v-model.trim="params.rate"></z-input>
				<z-input title="刷卡结算手续费率" placeholder="如：0.006" class="m-t-15" v-model.trim="params.car_rate"></z-input>
				<z-input title="结算周期" placeholder="T+1 请填 1、T+2 请填 2" class="m-t-15" v-model.trim="params.settlement_cycle"></z-input>
			</div>
			<div class="m-t-20 fx btn-adaption">
				<p class="w120 m-r-5 fx-shrink"></p>
				<a class="z-btn z-btn-primary b-r-3" @click="handleAddBtn">保存</a>
			</div>
		</section>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'

	export default {
		name: 'BusinessEdit',
		data() {
			return {
				params: {
					id: null, //店铺ID
					username: null, // 商家名称
					phone: null, //登录账号
					logo_url: null, // logo
					partnerId: null, //神马付SID
                    sign: null,//神马付签名
					private_key: null, //神马付私钥,
					public_key: null,//神马付公钥
					rate: null,//结算费率
					settlement_cycle: null,//结算周期
				}
			}
		},
		mounted() {
			const id = this.$route.query.id
			if(this.$re_Number(id)) this.handleGetBusinessInfo(id)
		},
		/*
		 * 属性计算
		 */
		computed: {},
		/*
		 * 事件处理
		 */
		methods: {
			handleUploadSuccess(url){
				this.params.logo_url = url;
			},
			//保存
			async handleAddBtn() {
				if(!this.params.username) return this.$warning('请填写商家名称( ･´ω`･ )');
				if(!this.$re_phone(this.params.phone)) return this.$warning('请填写商家登录账号( ･´ω`･ )');
				try{
					await this.saveBusiness(this.params);
					this.$success('操作成功');
					this.$back();
				}catch(e){
					this.$warning(e);
				}
			},

			//获取门店信息
			async handleGetBusinessInfo(id) {
				try{
					this.params = await this.getBusinessInfo({id})
				}catch(e){
					this.$errorMsg(e)
				}
			},
			...mapActions(['getBusinessInfo', 'saveBusiness']),
		}
	}
</script>
<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	#content {
		min-height: px-em(400px);
	}

	.c-g {
		color: $color-font-sub;
	}

	.content {
		border-top: none;
	}

	.detail-cont {
		width: 600px;
	}

	.question-api {
		position: relative;
		width: px-em(120px);
		height: px-em(120px);
		border: 1px solid $color-border;
		border-radius: px-em(4px);
		overflow: hidden;
		&:hover {
			.edit {
				opacity: 1;
			}
		}
		input {
			display: inline-block;
			width: px-em(120px);
			height: px-em(120px);
			opacity: 0;
			position: relative;
			z-index: 99;
			cursor: pointer;
		}
		img {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
		}
		.edit {
			opacity: 0;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.3);
			transition: all 0.2s ease;
			.icon {
				transition: all 0.2s ease;
				color: #fff;
				font-size: px-em(32px);
			}
		}
	}

	.file-btn {
		position: relative;
		width: px-em(200px);
		height: px-em(50px);
		overflow: hidden;
		cursor: pointer;
		&:hover {
			a {
				opacity: 0.8;
			}
		}
		a {
			position: absolute;
			width: 100%;
			height: 100%;
			z-index: 0;
		}
		input {
			position: absolute;
			display: block;
			opacity: 0;
			z-index: 1;
			width: 100%;
			height: 100%;
			cursor: pointer;
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.detail-cont{
			width: 100%;
		}
		.shop-tips{
			display: block;
		}
	}
</style>



// WEBPACK FOOTER //
// BusinessEdit.vue?6fb1b222